export { default as utcToZonedTime } from "date-fns-tz/utcToZonedTime/index.js";

// zoneExists :: String -> Boolean
export function zoneExists(str) {
  if (!Intl || !Intl.DateTimeFormat().resolvedOptions().timeZone) {
    throw new Error("Time zones are not available in this environment");
  }

  try {
    Intl.DateTimeFormat(undefined, { timeZone: str });
    return true;
  } catch (ex) {
    return false;
  }
}

// foreign import getJSDateComponentsLocal :: JSDate -> DateTimeRep
export function getJSDateComponentsLocal(jsDate) {
  return {
    year: jsDate.getFullYear(),
    month: jsDate.getMonth(),
    day: jsDate.getDate(), // Not a typo, this returns day of the month even thought it is called date
    hours: jsDate.getHours(),
    minutes: jsDate.getMinutes(),
    seconds: jsDate.getSeconds(),
    milliseconds: jsDate.getMilliseconds(),
  };
}
